var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{class:`d-flex p-2 w-100 justify-content-center align-items-center ${_vm.alertBgColor}`,attrs:{"dismissible":""},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }